import { createNotification } from '@repo/go-ui';
import type { TOptions } from 'i18next';

import { requireServiceAccessor } from 'src/packages/di';

export const DASHBOARD_NOTIFICATIONS_CONTAINER_ID = 'dashboard-notifications';

export interface INotificationsService {
  showErrorMessage(text: string): void;
  showErrorMessageT(text: string, options?: TOptions): void;
  showWarningMessage(text: string, title?: string): void;
  showWarningMessageT(text: string, options?: TOptions): void;
  showSuccessMessage(text: string): void;
  showSuccessMessageT(text: string, options?: TOptions): void;
}

export class NotificationsStore {
  constructor(private readonly getI18 = requireServiceAccessor('i18')) {}

  showErrorMessage(text: string): void {
    createNotification({
      containerId: DASHBOARD_NOTIFICATIONS_CONTAINER_ID,
      type: 'error',
      text,
    });
  }

  showErrorMessageT(text: string, options?: TOptions): void {
    const messageText = this.getI18().t(text, options);

    this.showErrorMessage(messageText);
  }

  showWarningMessage(text: string, title?: string): void {
    createNotification({
      containerId: DASHBOARD_NOTIFICATIONS_CONTAINER_ID,
      type: 'info',
      text,
      title,
    });
  }

  showWarningMessageT(text: string, options?: TOptions): void {
    const messageText = this.getI18().t(text, options);

    this.showWarningMessage(messageText);
  }

  showSuccessMessage(text: string): void {
    createNotification({
      containerId: DASHBOARD_NOTIFICATIONS_CONTAINER_ID,
      type: 'success',
      text,
    });
  }

  showSuccessMessageT(text: string, options?: TOptions): void {
    const messageText = this.getI18().t(text, options);

    this.showSuccessMessage(messageText);
  }
}
